export enum MLStore {
  CALIA = 'CALIA',
  DSG = 'DSG',
  FNS = 'FNS',
  G3 = 'G3',
  GG = 'GG',
  MJ = 'MJ',
  PL = 'PL',
  VRST = 'VRST'
}
